import { IconName } from "@/lib/modules";
import { Textarea } from "../textarea";
import { FormField } from "./FormField";

// ========== TEXTAREA FIELD ==========
type TextareaFieldProps = {
  label: string;
  name: string;
  placeholder?: string;
  defaultValue?: string;
  required?: boolean;
  helperText?: string;
  error?: string;
  rows?: number;
  icon?: IconName;
  tooltip?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  cols?: number;
};

export function TextareaField({
  label,
  name,
  placeholder,
  defaultValue,
  required = false,
  helperText,
  error,
  rows = 3,
  icon,
  tooltip,
  onChange,
  cols = 1,
}: TextareaFieldProps) {
  return (
    <FormField
      label={label}
      htmlFor={name}
      required={required}
      helperText={helperText}
      error={error}
      icon={icon}
      tooltip={tooltip}
    >
      <Textarea
        id={name}
        name={name}
        placeholder={placeholder}
        defaultValue={defaultValue}
        required={required}
        rows={rows}
        onChange={onChange}
        cols={cols}
      />
    </FormField>
  );
}
